module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-72x72-70e876b269bd2200904e8a659fd0f37d.png";